<app-layout-modulo-gerencial
  [logo]="sessao.logoEmpresa"
  [iniciais]="sessao.iniciaisEmpresa"
  [nome]="sessao.nomeEmpresa"
  [agora]="agora"
  [aba]="aba"
  [itens]="itensMenu"
  [mensagem]="mensagem"
  (selecionar)="sessao.abrir($event)"
  (sair)="sessao.sair()">

  <section class="panel p-4" *ngIf="aba === 'oficios'">
    <div class="d-flex flex-wrap gap-3 align-items-end justify-content-between mb-3">
      <div>
        <h2 class="h5 mb-1">Cadastro</h2>
        <div class="text-secondary small">Se ja existir numero cadastrado, a tela abre preenchida para edicao.</div>
      </div>
      <select
        class="form-select"
        *ngIf="empregadores.length > 1"
        [(ngModel)]="empregadorSelecionado"
        (ngModelChange)="aoTrocarEmpregador()"
        name="empregadorCadastro">
        <option value="">Empregador</option>
        <option *ngFor="let empregador of empregadores" [value]="empregador.id">{{ empregador.razaoSocial }}</option>
      </select>
    </div>

    <div class="row g-3">
      <div class="col-md-4" *ngFor="let cadastro of cadastros">
        <form class="border rounded-3 p-3 h-100" (ngSubmit)="salvarCadastro(cadastro)">
          <h3 class="h6 mb-3">{{ cadastro.rotulo }}</h3>
          <div class="mb-3">
            <label class="form-label" [for]="'numero' + cadastro.tipo">Numero</label>
            <input class="form-control" [id]="'numero' + cadastro.tipo" type="number" min="1" name="numero{{ cadastro.tipo }}" [(ngModel)]="cadastro.numero" required>
          </div>
          <div class="mb-3">
            <label class="form-label" [for]="'ano' + cadastro.tipo">Ano</label>
            <input class="form-control" [id]="'ano' + cadastro.tipo" type="number" min="2000" max="2100" name="ano{{ cadastro.tipo }}" [(ngModel)]="cadastro.ano" required>
          </div>
          <button class="btn btn-success w-100" type="submit">Salvar</button>
          <button type="button" class="btn btn-outline-primary w-100 mt-2" (click)="abrirReserva(cadastro)">Reservar</button>
        </form>
      </div>
    </div>
  </section>

  <section class="panel p-4" *ngIf="aba === 'oficios-lista'">
    <div class="d-flex flex-wrap gap-3 align-items-end justify-content-between mb-3">
      <div>
        <h2 class="h5 mb-1">Listagem</h2>
        <div class="text-secondary small">Consulta do que foi solicitado no portal. Excluir remove so solicitante e departamento.</div>
      </div>
    </div>

    <form class="row g-3 align-items-end mb-4" (ngSubmit)="filtrarLista()">
      <div class="col-md-3" *ngIf="empregadores.length > 1">
        <label class="form-label" for="empregadorLista">Empregador</label>
        <select class="form-select" id="empregadorLista" name="empregadorLista" [(ngModel)]="empregadorSelecionado" (ngModelChange)="aoTrocarEmpregador()">
          <option value="">Empregador</option>
          <option *ngFor="let empregador of empregadores" [value]="empregador.id">{{ empregador.razaoSocial }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label" for="dataInicialOficio">Inicio</label>
        <input
          class="form-control"
          id="dataInicialOficio"
          type="date"
          name="dataInicialOficio"
          [ngModel]="dataInicial"
          (ngModelChange)="alterarDataInicial($event)"
          required>
      </div>
      <div class="col-md-3">
        <label class="form-label" for="dataFinalOficio">Fim</label>
        <input
          class="form-control"
          id="dataFinalOficio"
          type="date"
          name="dataFinalOficio"
          [ngModel]="dataFinal"
          (ngModelChange)="alterarDataFinal($event)"
          required>
      </div>
      <div class="col-md-2">
        <label class="form-label" for="tipoFiltroOficio">Tipo Documento</label>
        <select class="form-select" id="tipoFiltroOficio" name="tipoFiltroOficio" [(ngModel)]="tipoFiltro">
          <option value="">Todos</option>
          <option *ngFor="let tipo of tipos()" [value]="tipo.id">{{ tipo.rotulo }}</option>
        </select>
      </div>
      <div class="col-md-1">
        <button class="btn btn-outline-primary w-100" type="submit">Filtrar</button>
      </div>
    </form>

    <p class="text-secondary small mb-2" *ngIf="resumoLista()">{{ resumoLista() }}</p>

    <div class="table-responsive" *ngIf="documentos.length; else vazio">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th>Acao</th>
            <th>Data</th>
            <th>Numero</th>
            <th>Ano</th>
            <th>Tipo Documento</th>
            <th>Solicitante</th>
            <th>Departamento do Servidor</th>
            <th>Finalidade</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of documentos">
            <td>
              <div class="d-flex gap-1">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="emEdicao(item) ? salvarLista(item) : editar(item)"
                  [title]="emEdicao(item) ? 'Salvar' : 'Editar'"
                  [attr.aria-label]="emEdicao(item) ? 'Salvar' : 'Editar'">
                  <i class="bi" [ngClass]="emEdicao(item) ? 'bi-floppy' : 'bi-pencil-square'"></i>
                </button>
                <button
                  *ngIf="!emEdicao(item)"
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  title="Excluir"
                  aria-label="Excluir"
                  (click)="excluirSolicitante(item)">
                  <i class="bi bi-x-lg"></i>
                </button>
                <button
                  *ngIf="emEdicao(item)"
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  title="Limpar"
                  aria-label="Limpar"
                  (click)="limparEdicao()">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </td>
            <ng-container *ngIf="emEdicao(item); else leitura">
              <td><input class="form-control form-control-sm" type="date" [(ngModel)]="item.dataSolicitacao" [name]="'data' + item.id"></td>
              <td><input class="form-control form-control-sm" type="number" min="1" [(ngModel)]="item.numero" [name]="'numero' + item.id"></td>
              <td><input class="form-control form-control-sm" type="number" min="2000" max="2100" [(ngModel)]="item.ano" [name]="'ano' + item.id"></td>
              <td>
                <select class="form-select form-select-sm" [(ngModel)]="item.tipo" [name]="'tipo' + item.id">
                  <option *ngFor="let tipo of tipos()" [value]="tipo.id">{{ tipo.rotulo }}</option>
                </select>
              </td>
              <td>{{ item.solicitante || '—' }}</td>
              <td>{{ item.departamento || '—' }}</td>
              <td>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  maxlength="20"
                  [(ngModel)]="item.finalidade"
                  [name]="'finalidadeEdicao' + item.id">
              </td>
            </ng-container>
            <ng-template #leitura>
              <td>{{ formatarData(item.dataSolicitacao) }}</td>
              <td>{{ item.numero }}</td>
              <td>{{ item.ano }}</td>
              <td>{{ rotuloTipo(item.tipo) }}</td>
              <td>{{ item.solicitante || '—' }}</td>
              <td>{{ item.departamento || '—' }}</td>
              <td>{{ item.finalidade || '—' }}</td>
            </ng-template>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #vazio>
      <p class="text-secondary mb-0">Nenhum documento neste periodo.</p>
    </ng-template>

    <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mt-3" *ngIf="totalPaginas > 1">
      <span class="text-secondary small">Pagina {{ pagina }} de {{ totalPaginas }}</span>
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          [disabled]="pagina <= 1"
          (click)="irParaPagina(pagina - 1)">
          Anterior
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          [disabled]="pagina >= totalPaginas"
          (click)="irParaPagina(pagina + 1)">
          Proxima
        </button>
      </div>
    </div>
  </section>

  <div *ngIf="modalReservaAberta" class="modal-backdrop-custom" (click)="fecharReserva()">
    <div class="modal-card modal-card-reserva" (click)="$event.stopPropagation()">
      <div class="modal-header-custom">
        <h3 class="h5 mb-0">Reservar {{ reservaRotulo }}</h3>
        <button type="button" class="btn btn-light btn-sm" (click)="fecharReserva()" aria-label="Fechar">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <form class="modal-body-custom" (ngSubmit)="confirmarReserva()">
        <label class="form-label" for="quantidadeReserva">Informe a quantidade que deseja reservar</label>
        <input
          class="form-control"
          id="quantidadeReserva"
          type="number"
          min="1"
          max="100"
          name="quantidadeReserva"
          [(ngModel)]="reservaQuantidade"
          required
          autofocus>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-outline-secondary" (click)="fecharReserva()">Cancelar</button>
          <button type="submit" class="btn btn-primary">Reservar</button>
        </div>
      </form>
    </div>
  </div>
</app-layout-modulo-gerencial>
